import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import hoastLogo from "../../../assets/images/HOAST-LOGO_2 1.png";
import { useState, useEffect } from 'react';
import { getTermsConditionsAPI } from '../../../service/ApiServices';
import DOMPurify from 'dompurify';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function PrivacyPolicy() {
    const [privacyPolicy, setPrivacyPolicy] = useState(null);
    const [loading, setLoading] = useState(true);

    const ContentSkeleton = () => {
        return (
            <div className="space-y-6">
                <Skeleton height={40} width="60%" />
                <Skeleton height={16} width="30%" />
                
                {[...Array(5)].map((_, index) => (
                    <div key={index} className="space-y-3">
                        <Skeleton height={28} width="40%" />
                        <Skeleton height={14} count={3} />
                        <Skeleton height={14} width="90%" />
                    </div>
                ))}
            </div>
        );
    };

    const HtmlContent = ({ htmlString }) => {
        const sanitizedHtml = DOMPurify.sanitize(htmlString);
        const style = `
        .html-content-wrapper {
          word-wrap: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
          font-size: 16px;
          line-height: 1.6;
          color: #1a1a1a;
        }
        .html-content-wrapper ol {
          margin: 1em 0 1em 1.5em;
          padding-left: 0.5em;
          list-style-type: decimal;
        }
        .html-content-wrapper ul {
          margin: 1em 0 1em 1.5em;
          padding-left: 0.5em;
          list-style-type: disc;
        }
        .html-content-wrapper li {
          margin-bottom: 0.6em;
          line-height: 1.6;
          padding-left: 0.5em;
        }
        .html-content-wrapper h1 {
          font-size: 2em;
          font-weight: 700;
        //   margin: 1.2em 0 0.8em 0;
          line-height: 1.3;
          color: #000;
        }
        .html-content-wrapper h2 {
          font-size: 1.5em;
          font-weight: 700;
          margin: 1.2em 0 0.6em 0;
          line-height: 1.4;
          color: #000;
        }
        .html-content-wrapper h3 {
          font-size: 1.25em;
          font-weight: 600;
          margin: 1em 0 0.5em 0;
          line-height: 1.4;
          color: #000;
        }
        .html-content-wrapper h4,
        .html-content-wrapper h5,
        .html-content-wrapper h6 {
          font-weight: 600;
          margin: 0.8em 0 0.4em 0;
          line-height: 1.4;
          color: #000;
        }
        .html-content-wrapper p {
          margin: 0.7em 0;
          word-break: break-word;
          line-height: 1.6;
        }
        .html-content-wrapper strong,
        .html-content-wrapper b {
          font-weight: 600;
          color: #000;
        }
        .html-content-wrapper a {
          color: #2563EB;
          text-decoration: underline;
          word-break: break-all;
        }
        .html-content-wrapper > *:first-child {
          margin-top: 0;
        }
      `;

        return (
            <div
                className="html-content-wrapper"
                dangerouslySetInnerHTML={{
                    __html: `<style>${style}</style>${sanitizedHtml}`,
                }}
            />
        )
    }

    useEffect(() => {
        const params = {
            content_type: 'privacy_policy',
            role: 'artist'
        }
        setLoading(true);
        getTermsConditionsAPI(params)
            .then((res) => {
                setPrivacyPolicy(res?.data?.data?.content);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="bg-white shadow-sm border-b">
                <div className="container mx-auto p-4">
                    <div className="flex items-center justify-between">
                        <Link to={-1} className="flex items-center text-gray-600 hover:text-gray-800">
                            <ArrowLeft size={20} className="mr-2" />
                            Back to Login
                        </Link>
                        <img src={hoastLogo} alt="Logo" className="h-12" />
                    </div>
                </div>
            </div>

            <div className="container mx-auto py-4">
                <div className="bg-white rounded-xl shadow-md p-4 md:p-8">
                    {loading ? (
                        <ContentSkeleton />
                    ) : (
                        <HtmlContent htmlString={privacyPolicy} />
                    )}
                </div>
            </div>
        </div>
    );
} 